import { KYMW0E00Model } from '../kymw0e00.model';
import { KYMW0E00InputModel } from '../vo/kymw0e00-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 紐付商品コードを指定し、紐付商品単位に商品情報を取得する
 *
 * @export API通信成功時の処理
 * @class DeleteUserService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetChangeInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0E00Model;
  private successFunc: Function;
  private vo: KYMW0E00InputModel;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteUserService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProcessDiv: this.vo.processDiv,
        ImageId: this.vo.imageID,
        StartOrderCodeAfter: this.vo.startOrderCodeAfter,
        EndOrderCodeAfter: this.vo.endOrderCodeAfter,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW0E00Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof DeleteUserService
   */
  execute(model: KYMW0E00Model, vo: KYMW0E00InputModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getChangeInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteUserService
   */
  success(data: any) {
    this.model.getUsePage(data);
  }
  public validationError(data: any): void {
    super.validationError(data);
    this.err();
  }

  /**
   * @copy jp.co.toppan.pless.common.commands.PlessResponder#systemErrorHandler(data:Object)
   */
  public systemErrorHandler(errList: Object): void {
    super.systemErrorHandler(errList);
    this.err();
  }
  /**
   * 自画面を閉じる
   */
  private err(): void {
    // 呼出元画面に「2:キャンセル」を通知し、以降の処理は行わない
    this.model.kymw0E00Component.exitKYMW0E00(2);
  }
}

